import type React from 'react';
import SvgIcon from './SvgIcon';

const QuestionMarkCircle: React.FC = () => (
  <SvgIcon
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g id="QuestionMarkCircle">
      <path d="M12.0002 15.0002C12.8282 15.0002 13.5002 15.6722 13.5002 16.5002C13.5002 17.3282 12.8282 18.0002 12.0002 18.0002C11.1722 18.0002 10.5002 17.3282 10.5002 16.5002C10.5002 15.6722 11.1722 15.0002 12.0002 15.0002Z" fill="currentColor" />
      <path d="M12.0002 5.75022C14 5.75025 15.5001 7.27933 15.5002 9.21018C15.5002 10.1919 15.0958 11.0185 14.428 11.5959C14.0169 11.9512 13.5257 12.196 13.0002 12.342V13.2502H11.0002V10.5608L11.9377 10.5022C12.4658 10.4693 12.8685 10.3 13.1203 10.0823C13.3531 9.88088 13.5002 9.6051 13.5002 9.21018C13.5001 8.38761 12.8991 7.75025 12.0002 7.75022C11.1019 7.75025 10.4232 8.40143 10.2326 9.39768L8.2678 9.02268C8.58996 7.3367 9.90548 5.75025 12.0002 5.75022Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.92893 4.92893C8.83417 1.02369 15.1663 1.02369 19.0715 4.92893C22.9768 8.83418 22.9768 15.1663 19.0715 19.0715C15.1663 22.9768 8.83418 22.9768 4.92893 19.0715C1.02369 15.1663 1.02369 8.83418 4.92893 4.92893ZM17.6574 6.34299C14.5333 3.2188 9.46719 3.2188 6.34299 6.34299C3.2188 9.46719 3.2188 14.5333 6.34299 17.6574C9.46719 20.7816 14.5333 20.7816 17.6574 17.6574C20.7816 14.5333 20.7816 9.46719 17.6574 6.34299Z"
        fill="currentColor" />
    </g>
  </SvgIcon>
);

export default QuestionMarkCircle;
